import Select, { Styles, OptionTypeBase } from 'react-select';

import { Option } from './config';

import styles from '../index.module.css';

const selectStyle: Styles<Option, false> = {
  menu: (provided) => ({
    ...provided,
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    textAlign: 'right',
    justifyContent: 'flex-end',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: 'none',
    fontSize: '0.875rem',
    fontFamily: 'inherit',
    border: '0',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'inherit',
    color: '#808080',
  }),
  valueContainer: (provided) => ({
    ...provided,
    textAlign: 'right',
    border: '1px solid rgba(0,0,0,0)',
    justifyContent: 'flex-end',
    padding: '0',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
};

function getOptionFromValue<T extends OptionTypeBase>(
  value: string,
  optionList: T[],
): T | undefined {
  if (!value) return undefined;
  return optionList.find((option) => value === option.value);
}

interface PaymentRowSelectInputProps {
  label: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
}

const PaymentRowSelectInput: React.FC<PaymentRowSelectInputProps> = ({
  label,
  value,
  options,
  onChange,
}) => {
  return (
    <div className={styles.Row}>
      <div className={styles.Label}>{label}</div>
      <Select
        className={styles.BillingSelect}
        styles={selectStyle}
        value={getOptionFromValue(value, options)}
        placeholder="California"
        options={options}
        onChange={(option) => {
          if (!option) return;
          onChange(option.value);
        }}
        isMulti={false}
      />
    </div>
  );
};

export default PaymentRowSelectInput;
